import { Routes } from '@angular/router';
import { AuthComponent } from './auth/auth.component';
import { AuthenticationGuard } from './auth/authentication.guard';
import { UnprotectedLayoutComponent } from './unprotected/unprotected-layout.component';

export const appRoutes: Routes = [
    {
        path: '',
        redirectTo: 'app',
        pathMatch: 'full',
    },
    {
        path: 'auth',
        component: AuthComponent,
        loadChildren: () => import('./auth/auth.routes'),
    },
    {
        path: 'app',
        loadChildren: () => import('./pages/pages.routes'),
        canActivate: [AuthenticationGuard],
    },
    {
        path: '',
        component: UnprotectedLayoutComponent,
        children: [
            {
                path: 'broker',
                loadComponent: () =>
                    import(
                        './unprotected/unprotected-commission/unprotected-commission.component'
                    ).then((m) => m.UnprotectedCommissionComponent),
            },
            {
                path: 'client',
                loadComponent: () =>
                    import(
                        './unprotected/unprotected-client/unprotected-client.component'
                    ).then((m) => m.UnprotectedClientComponent),
            },
            {
                path: 'invoice',
                loadComponent: () =>
                    import('./unprotected/invoice/invoice.component').then(
                        (m) => m.InvoiceComponent,
                    ),
            },
            {
                path: 'invoice-summary',
                loadComponent: () =>
                    import(
                        './unprotected/summary-report/summary-report.component'
                    ).then((m) => m.UnprotectedSummaryReportComponent),
            },
            {
                path: 'confirm-invitation',
                loadComponent: () =>
                    import(
                        './unprotected/confirm-invitation/confirm-invitation.component'
                    ).then((m) => m.ConfirmInvitationComponent),
            },
            {
                path: 'reset-password',
                loadComponent: () =>
                    import(
                        './unprotected/reset-password/reset-password.component'
                    ).then((m) => m.ResetPasswordComponent),
            },
            {
                path: 'thank-you',
                loadComponent: () =>
                    import(
                        './unprotected/thank-you-page/thank-you-page.component'
                    ).then((m) => m.ThankYouPageComponent),
            },
            {
                path: 'reports',
                loadComponent: () =>
                    import('./unprotected/reports/reports.component').then(
                        (m) => m.ReportsComponent,
                    ),
                children: [
                    {
                        path: '**', // catch all child routes under /reports/*
                        loadComponent: () =>
                            import(
                                './unprotected/reports/reports.component'
                            ).then((m) => m.ReportsComponent),
                    },
                ],
            },
            {
                path: 'client/reports',
                loadComponent: () =>
                    import(
                        './unprotected/client-reports/client-reports.component'
                    ).then((m) => m.ClientReportsComponent),
                children: [
                    {
                        path: '**', // catch all child routes under /reports/*
                        loadComponent: () =>
                            import(
                                './unprotected/client-reports/client-reports.component'
                            ).then((m) => m.ClientReportsComponent),
                    },
                ],
            },
            {
                path: 'broker/reports',
                loadComponent: () =>
                    import(
                        './unprotected/broker-reports/broker-reports.component'
                    ).then((m) => m.BrokerReportsComponent),
            },
            {
                path: 'invoice-commission-report',
                loadComponent: () =>
                    import(
                        './pages/commission-runs/invoice-commission-report/invoice-commission-report.component'
                    ).then((m) => m.InvoiceCommissionReportComponent),
            },
            {
                path: 'invoice-summary-report/:id',
                loadComponent: () =>
                    import(
                        './pages/invoice/summary-report/summary-report.component'
                    ).then((m) => m.SummaryReportComponent),
            },
            {
                path: 'invoice-detailed-billing-report/:id',
                loadComponent: () =>
                    import(
                        './pages/invoice/detailed-billing-report/detailed-billing-report.component'
                    ).then((m) => m.DetailedBillingReportComponent),
            },
            {
                path: 'commission-run/report/broker-statement',
                loadComponent: () =>
                    import(
                        './unprotected/broker-statement-report/broker-statement-report.component'
                    ).then((m) => m.BrokerStatementReportComponent),
            },
        ],
    },
    { path: '**', redirectTo: 'app' },
];
